// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_14Dp6","header":"index_header_1pa57"};